import dayjs from 'dayjs';
import type { Address, UtilitiesForm } from '@utilities/types';

type SourceLike = {
  sourceMethod?: string | null;
} | null;

const hasNonEmpty = (value: string | null | undefined): boolean =>
  typeof value === 'string' && value.trim().length > 0;

export function hasDisplayableAddress(
  address: Address | null | undefined,
): boolean {
  if (!address) {
    return false;
  }

  return (
    hasNonEmpty(address.line1) ||
    hasNonEmpty(address.street) ||
    hasNonEmpty(address.houseNo) ||
    hasNonEmpty(address.city) ||
    hasNonEmpty(address.postcode)
  );
}

export function isFormUploadSource(source: SourceLike): boolean {
  return source?.sourceMethod === 'Form upload';
}

export function buildUtilitiesFormAddressString(
  form: Pick<UtilitiesForm, 'address' | 'createdAt' | 'source'>,
): string {
  if (
    isFormUploadSource(form.source) &&
    !hasDisplayableAddress(form.address)
  ) {
    return `Unprocessed form uploaded ${dayjs(form.createdAt).format('DD/MM/YYYY')}`;
  }

  if (!form.address) {
    return '';
  }

  const parts: string[] = [];

  if (hasNonEmpty(form.address.line1)) {
    parts.push(form.address.line1!.trim());
  }

  if (hasNonEmpty(form.address.city)) {
    parts.push(form.address.city!.trim());
  }

  if (hasNonEmpty(form.address.postcode)) {
    parts.push(form.address.postcode!.trim());
  }

  return parts.join(', ');
}
